import { listingSelector, userSelector } from '../selectors';
import { useSelector } from 'react-redux';

export function useListingUser() {
  const listing = useSelector(listingSelector);
  const user = useSelector(userSelector);

  return { listing, user };
}
